export default "__VITE_ASSET__587a6341__"